
import React from 'react'
import styled from 'styled-components'

const AttachmentMenu = ({ optionsList }) => {
    return (
        <Container>
            {optionsList?.map((item, index) => (
                <Item onClick={item.action} key={index}>
                    {item.icon}
                    <p>{item.text}</p>
                </Item>
            ))}
        </Container>
    )
}

export default AttachmentMenu

const Container = styled.div`
display:flex;
flex-direction:column;
border-radius:12px;
background: ${({ theme }) => theme.menu.groupContentBackground};
max-width:200px;
width:200px;
overflow:hidden;
box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); 
:last-child{
    border:none;
}
`

const Item = styled.div`
display:flex;
align-items:center;
padding:10px 20px;
width:100%;
color: ${({ theme }) => theme.menu.primaryTextColor};
border-bottom:0.5px solid  ${({ theme }) => theme.sidebar.borderColor};
gap:5px;
cursor:pointer;
svg{
    fill:${({ theme }) => theme.chat.mediaBtnBorder};
    color:${({ theme }) => theme.chat.mediaBtnColor};
}

&:hover{
color: ${({ theme }) => theme.menu.primaryTextColor};
    background: ${({ theme }) => theme.menu.enterPhoneNumberBackground};
    svg{
         fill:${({ theme }) => theme.chat.mediaBtnBorder};
    }
}
`